import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Recall } from 'models/RecallModel';
import { ControlSession } from 'components/common/ControlSession';

const RecallList: React.FC = () => {
  const width = { type: 12, client: 18, comment: 28, date: 12, status: 12, user:12 }
  const [formId, formName] = [Code.Form.Id.RECALL, Code.Form.Name.RECALL];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [recallData, setRecallData] = useState<Recall[]>([]); 
  const [selectedRecall, setselectedRecall] = useState<Recall | null>(null);
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [statusId, setStatusId] = useState<number>(1);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const triggers = [pno, pageRows, search, activeId, statusId, startDate, endDate];
  const Privilege = Hooks.Privilege.List(formId);
  const PriClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  const locationId = Utility.Storage.LocationId();
  
  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.OPTION+Code.Group.RECALL_STATUS, Code.Option.Common.ALL, setStatusOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Recall.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Recall.Date, 
        Name.Common.TypeName, 
        Name.Client.Id, 
        Name.Client.FullName, 
        Name.Recall.Comment, 
        Name.Recall.CallDate, 
        Name.Common.StatusName, 
        Name.User.FullName
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
      ...(statusId != 1 && { status_id: statusId }),
      ...(startDate != '' && { start_date: startDate }),
      ...(endDate != '' && { end_date: endDate }),
    });
     
    await API.Data.List<Recall>(url, setRecallData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <ControlSession startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
              <Control.Dropdown title={Title.Status} value={statusId} options={statusOptions} onChange={setStatusId} />
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, recallData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.ClientName, width.client],
                [Title.Comment, width.comment], 
                [Title.Status, width.status], 
                [Title.Type, width.type],
                [Title.Date, width.date], 
                [Title.UserName, width.user], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(recallData) && (
              <Control.Grid.Row>
                {recallData.map((recallData) => { return (
                <Control.Grid.Data<Recall> key={recallData.recall_id} itemKey={recallData.recall_key} data={recallData} setMenuPosition={setMenuPosition} setSelectedData={setselectedRecall} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={recallData.recall_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, recallData.recall_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Link value={Utility.Get.FullName(recallData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(PriClient, Code.Form.Name.CLIENT, recallData.client_id)} width={width.client} iframeRef={iframeRef} />
                  <Control.Grid.Items values={[
                    [recallData.recall_comment, width.comment],
                    [recallData.status_name, width.status],
                    [recallData.type_name, width.type],
                    [Utility.Format.DateOnly(recallData.recall_call_date), width.date],
                    [Utility.Get.FullName(recallData,Code.Form.Name.USER), width.user],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={recallData.recall_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={recallData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName, selectedRecall?.recall_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedRecall?.recall_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default RecallList;